<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-master-major" data-bs-toggle="modal" data-bs-target="#master-major-modal-form">Klik</button>
        <div class="modal" id="master-major-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="form-group form-style-1">
                                    <label class="form-label">Nama Jurusan<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <input type="text" class="form-control error" placeholder="Masukan nama Jurusan" v-model="form.name" required oninvalid="this.setCustomValidity('Masukan nama Jurusan')" oninput="this.setCustomValidity('')">
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-master-major">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'MasterMajorForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id            : "",
                name          : ""
            },
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            name: {
                required
            }
        }
    },
    methods: {
        loadForm: function(params="") {
            if(params == '') {
                this.label = 'Tambah';
                this.clearForm();
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-master-major').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-master-major').click();
            this.$parent.$children[0].$children[0].getData();
            this.clearForm();
        },
        clearForm: function() {
            for (let key in this.form) {
                this.form[key] = '';
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    formData.append(key, this.form[key]);
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'administrator/master-major/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'administrator/master-major/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];
                            }
                        }
                    }
                });
            }
        }
    },
}
</script>
